import React from 'react';

export default function GameTypeBadge({ type }) {
  return (
    <span className={`type-pill type-pill-${type}`}>
      {type === 'online' ? 'Online' : 'In-Person'}
    </span>
  );
}
